var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export var TextInput = React.forwardRef(function (props, ref) {
    var className = props.className, childProps = __rest(props, ["className"]);
    return (_jsx("input", __assign({ ref: ref, className: "".concat(className !== null && className !== void 0 ? className : "", " bg-black-1000 ").concat((childProps === null || childProps === void 0 ? void 0 : childProps.disabled) ? "" : "hover:bg-black-800", " rounded-[10px] px-[24px] py-[16px] font-N8") }, childProps)));
});
